import { PlayCircleIcon } from '@phosphor-icons/react';
import Fancybox from '../../lib/FancyBox';

const YoutubeVideoSolution = ({
  videoId,
  videoThumbnail = null,
  isSolution = true,
  testId = null,
  testTitle = null,
  subjectTitle = null,
  chapterTitle = null,
  topicTitle = null,
  conceptTitle = null,
  questionType = null,
  questionLevel = null,
  attemptStatus = null,
  source = null,
}) => {
  const selectedPack = JSON.parse(window.localStorage.getItem('selectedPack') || 'null');
  const user = JSON.parse(window.localStorage.getItem('userProfile') || 'null');

  return (
    <div>
      {isSolution && <span className="font-medium text-[13px] text-[var(--q3-neutral-light)]">VIDEO SOLUTION</span>}
      <div className={`${isSolution && 'mt-3'}`}>
        <Fancybox>
          <a
            href={`https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`}
            data-fancybox
            data-type="iframe"
            className={`relative block ${isSolution ? 'w-fit' : 'w-full'} overflow-hidden`}
            // onClick={handleVideoClick}
          >
            <img
              src={videoThumbnail || `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
              alt="Video thumbnail"
              className={`object-cover ${isSolution ? 'w-2xs' : 'w-full'} h-auto rounded-xl`}
            />
            <div className="absolute inset-0 bg-black opacity-30 rounded-xl" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-gray-800 text-white p-2 border border-gray-300 rounded-full shadow text-sm font-medium flex items-center gap-2">
                <PlayCircleIcon size={20} />
                <span>View {isSolution ? 'Solution' : 'Analysis'}</span>
              </div>
            </div>
          </a>
        </Fancybox>
      </div>
    </div>
  );
};

export default YoutubeVideoSolution;
